const AuthApi = {
    postAuthLogin: '/auth/login',
    postAuthProfile: '/auth/profile',

    getAuthLogout: '/auth/logout',
    getAuthCheckToken: '/auth/check-token',
}

export default AuthApi;
